import type { CustomerVideo, Store, UseCase, VideoPageInfo } from 'src/api/models';

export interface VideosContext {
  object: CustomerVideo;
  hyperlinkVideoUrl: string;
  videoPageInfo: VideoPageInfo;
  useCaseInfo: UseCase;
  storeInfo: Store;
  genericVideo: boolean;
  lang: 'en' | 'es';
  couponCode: string | null;
  ctaUrl: string | null;
  deliveryMethod: 'SMS' | 'EMAIL' | null;

  // Posthog Attribution related values
  email: string | null;
  phone: string | null;
  endCustomerId: string | null;
  customerFirstName: string | null;
}

export const LocalizedStrings = {
  en: {
    hello: (name: string | null) => (name ? `Hi ${name}!` : 'Hi there!'),
    heart: () => 'Love',
    videoSendMessage: () => `Hope you enjoyed the video! Send me a few words, I'd love to hear from you.`,
    heartSendMessage: () => `I'm happy that you liked the video! Send me a few words, I'd love to hear from you.`,
    replyPlaceholder: (name: string) => `Reply to ${name}...`,
    thanksForReply: () => 'Thanks for your reply! Your message is on its way.',
  },
  es: {
    hello: (name: string | null) => (name ? `¡Hola ${name}!` : '¡Hola!'),
    heart: () => 'Me encanta',
    videoSendMessage: () =>
      '¡Espero que hayas disfrutado del video! ¡Escríbeme algunas palabras, me encantaría escuchar de ti!',
    heartSendMessage: () =>
      '¡Estoy feliz que te gusto el video! ¡Escríbeme algunas palabras, me encantaría escuchar de ti!',
    replyPlaceholder: (name: string) => `Responde a ${name}...`,
    thanksForReply: () => '¡Gracias por su respuesta!',
  },
};
